import { useState } from "react";
import "./faq.css";

const faqs = [
  {
    question: "What material are your totes made from?",
    answer:
      "Our totes are crafted from durable, reusable canvas designed for everyday use. We focus on quality materials that are both long-lasting and eco-conscious.",
  },
  {
    question: "Are the bags sustainable?",
    answer:
      "Yes. Tote Therapy bags are made to be reusable and reduce reliance on single-use plastic bags. We believe mindful living includes mindful choices.",
  },
  {
    question: "What are the dimensions of the tote?",
    answer:
      "Each tote is designed to comfortably carry your daily essentials, including laptops, books, and personal items.",
  },
  {
    question: "How long does delivery take?",
    answer:
      "Delivery typically takes 2–4 working days within the UAE.",
  },
  {
    question: "Do you accept returns?",
    answer:
      "All items are final sale. We accept exchanges only in case of manufacturing defects reported within 48 hours of delivery.",
  },
  {
    question: "How should I care for my tote?",
    answer:
      "We recommend gentle hand washing or spot cleaning to maintain the print and fabric quality. Avoid machine washing and high heat.",
  },
  {
    question: "Do you offer custom designs?",
    answer:
      "Yes. We offer custom quotes and personalized designs. Contact us via WhatsApp for inquiries.",
  },
  {
    question: "How can I contact you?",
    answer:
      "You can reach us directly through WhatsApp or email. We aim to respond within 24 hours.",
  },
  {
    question: "Is this a therapy service?",
    answer:
      "No. Tote Therapy is a lifestyle brand focused on mental awareness through meaningful design. We do not provide medical or therapeutic services.",
  },
];

export default function FAQ() {
  const [active, setActive] = useState(null);

  return (
    <main className="faqPage">
      <div className="faqContainer">
        <h1>Frequently Asked Questions</h1>

        <div className="faqList">
          {faqs.map((item, index) => (
            <div
              key={index}
              className={`faqItem ${active === index ? "open" : ""}`}
              onClick={() => setActive(active === index ? null : index)}
            >
              <div className="faqQuestion">
                <span>{item.question}</span>
                <span className="faqIcon">
                  {active === index ? "−" : "+"}
                </span>
              </div>

              {active === index && (
                <div className="faqAnswer">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}